export default __webpack_public_path__ + "static/media/dragon2.1421c386.png";